import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import defineTimeOptions from './utils';
import './styles.css';

const Event = ({ event, intl }) => {
  const { type = '', start, pendingStatus, title, backgroundColor, borderColor } = event;
  const { formatTime } = intl;
  const timeOptions = defineTimeOptions(start);
  const startTime = formatTime(start, timeOptions).replace(/\s/, '');
  const pending = pendingStatus ? 'pending' : '';
  const isImportedEvent = type === 'google';

  const styleName = !isImportedEvent ? `cal-event ${type} ${pending}` : 'cal-event';

  return (
    !!event.highSchool && (
    <button type="button" styleName="event-button">
      <h4
        styleName={styleName}
        style={isImportedEvent ? {
          background: backgroundColor,
          borderLeft: `3px solid ${borderColor}`,
          color: '#FFFFFF',
        } : null}
      >
        <span>{title}, </span><span className="rbc-event-time">{`${startTime}`}</span>
      </h4>
    </button>
    ));
};

Event.propTypes = {
  event: PropTypes.object.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(Event);
